import { render, staticRenderFns } from "./yuefengren.vue?vue&type=template&id=74f9459c&scoped=true&"
import script from "./yuefengren.vue?vue&type=script&lang=js&"
export * from "./yuefengren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f9459c",
  null
  
)

export default component.exports